import React, { useContext, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { useHistory } from "react-router-dom";
import ActionTable from "../../components/table/ActionTable";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";

const listaSituacao = [
  { id: 1, nome: "Solicitado" },
  { id: 2, nome: "Aguardando pagamento" },
  { id: 3, nome: "Enviado" },
  { id: 4, nome: "Cancelado" },
  { id: 5, nome: "Expirado" },
];

export default function Lista({ location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        codigo: "",
        situacao: 0,
        usuarioNome: "",
        usuarioEmail: "",
        usuarioCPF: "",
        exibirCancelados: false,
      },
      location
    )
  );
  const [registros, setRegistros] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  useEffect(() => {
    listar();
  }, []);

  const listar = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    api
      .get("pedidosExternos/listar", filtrosEnviar)
      .then((res) => {
        const registros = res;
        registros.forEach((r) => {
          r.data = formatDateTime(r.registro, "D/M/Y h:m");
          r.status =
            listaSituacao.find((situacao) => situacao.id === r.situacao)
              ?.nome || "Situação não encontrada";

          if (r.situacao === 2) {
            if (r.modalidadePagamento === 1) {
              r.status = "Aguadando pagamento (boleto bancário)";
            }
            if (r.modalidadePagamento === 2) {
              r.status = "Aguadando pagamento (cartão de crédito)";
            }
            if (r.modalidadePagamento === 3) {
              r.status = "Aguadando pagamento (pix)";
            }
          }
        });
        setRegistros(registros);
        setCarregando(false);
      })
      .catch((e) => {
        notification(
          "error",
          "Não foi possível listar os acompanhamentos. Verifique sua conexão e tente novamente."
        );
        setCarregando(false);
      });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      codigo: {
        label: "Código",
        type: "text",
        space: 3,
        value: filtros.codigo,
      },
      situacao: {
        label: "Situação",
        type: "select",
        emptyItem: true,
        emptyItemText: "(todas)",
        space: 3,
        array: {
          data: listaSituacao,
          value: "id",
          desc: "nome",
        },
        value: filtros.situacao,
      },
      exibirCancelados: {
        label: "Exibir cancelados",
        type: "check",
        space: 6,
        value: filtros.exibirCancelados,
      },
      responsavelNome: {
        label: "Nome do responsável",
        type: "text",
        space: 6,
        value: filtros.responsavelNome,
      },
      responsavelEmail: {
        label: "Email do responsável",
        type: "text",
        space: 3,
        value: filtros.responsavelEmail,
      },
      responsavelCPF: {
        label: "CPF do responsável",
        type: "text",
        space: 3,
        value: filtros.responsavelCPF,
      },
    },

    submit: {
      label: "Buscar",
      action: listar,
    },

    urlParams: true,
    history,
    location,
  };

  const tPedidos = {
    title: "Pedidos",
    onLineClick: (id) => history.push(`/app/pedidos-livraria/${id}`),
    key: "id",
    columns: [
      {
        label: "Código",
        name: "id",
      },
      {
        label: "Registro",
        name: "data",
      },
      {
        label: "Responsável",
        name: "responsavelNome",
      },
      {
        label: "Situação",
        name: "status",
      },
    ],
    array: registros,
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? <CircularProgress /> : <ActionTable structure={tPedidos} />}
    </div>
  );
}
